import React from 'react';
import { useTranslation } from 'react-i18next';
import MarketingLayout from '../components/MarketingLayout';

const SUPPORT_EMAIL = 'support.betterhusband@gmail.com';

const T = {
  en: {
    hero_label: 'Support',
    hero_title: "We're here to help",
    hero_sub: 'The best way to reach us is by email. We typically respond within 24 hours.',
    card_title: 'Contact Support',
    card_desc: "Send us an email and we'll get back to you as soon as possible.",
    email_label: 'Email us at',
  },
  it: {
    hero_label: 'Supporto',
    hero_title: 'Siamo qui per aiutarti',
    hero_sub: 'Il modo migliore per contattarci è via email. Di solito rispondiamo entro 24 ore.',
    card_title: 'Contatta il supporto',
    card_desc: 'Scrivici una email e ti risponderemo il prima possibile.',
    email_label: 'Scrivici a',
  },
  es: {
    hero_label: 'Soporte',
    hero_title: 'Estamos aquí para ayudarte',
    hero_sub: 'La mejor forma de contactarnos es por email. Solemos responder en 24 horas.',
    card_title: 'Contactar con soporte',
    card_desc: 'Envíanos un email y te responderemos lo antes posible.',
    email_label: 'Escríbenos a',
  },
};

const LandingSupport = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('it') ? 'it' : i18n.language?.startsWith('es') ? 'es' : 'en';
  const s = T[lang];

  return (
    <MarketingLayout>
      <main className="bh-container" style={{ paddingTop: 80, paddingBottom: 112, flex: 1 }}>
        <div style={{ maxWidth: 560, margin: '0 auto', textAlign: 'center' }}>
          <span className="bh-eyebrow">{s.hero_label}</span>
          <h1 style={{ fontSize: 'clamp(2.2rem, 4vw, 3rem)', marginBottom: 16 }}>{s.hero_title}</h1>
          <p className="bh-lead" style={{ marginBottom: 48 }}>{s.hero_sub}</p>

          <div className="bh-card" style={{ padding: '48px 32px', transform: 'none' }}>
            <div
              style={{
                width: 56, height: 56, borderRadius: '50%',
                margin: '0 auto 20px',
                backgroundColor: 'var(--chip)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="var(--forest)" strokeWidth={1.5}>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                />
              </svg>
            </div>
            <h2 style={{ fontSize: '1.4rem', marginBottom: 8 }}>{s.card_title}</h2>
            <p style={{ fontSize: 15, color: 'var(--muted)', marginBottom: 24 }}>{s.card_desc}</p>
            <p
              style={{
                fontSize: 12, fontWeight: 600, textTransform: 'uppercase',
                letterSpacing: '.12em', color: 'var(--muted)', marginBottom: 8,
              }}
            >
              {s.email_label}
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              style={{ fontSize: 17, fontWeight: 600, color: 'var(--forest)', wordBreak: 'break-all', textDecoration: 'none' }}
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </main>
    </MarketingLayout>
  );
};

export default LandingSupport;
